import { render, staticRenderFns } from "./CommercialInvoice.vue?vue&type=template&id=886ddd26&scoped=true&"
import script from "./CommercialInvoice.vue?vue&type=script&lang=js&"
export * from "./CommercialInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CommercialInvoice.vue?vue&type=style&index=0&id=886ddd26&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886ddd26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})
